export function createObjectURLSafe(blob: unknown): string | null {
  if (blob != null && blob instanceof Blob) {
    const urlCreator = window.URL || window.webkitURL
    return urlCreator.createObjectURL(blob)
  }
  return null
}

/**
 * Building-context image payload matching useImagesQuery / SafetyTag create needs.
 * Prefer single-image response for calibration (height, x/y).
 */
export async function buildBuildingImageData({
  selectedImage,
  viewpointsImage,
  imageUrl,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- viewpoint list + API shapes vary
  selectedImage: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- fetchPointImage response
  viewpointsImage: any
  imageUrl: string
}): Promise<{
  image: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- processed_image_object shape
  processed_image: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- merged viewpoint data
  data: any
  dimensions: { width: number; height: number }
}> {
  const img = new Image()
  await new Promise<void>((resolve, reject) => {
    img.onload = () => resolve()
    img.onerror = () =>
      reject(new Error(`Failed to load building image: ${imageUrl}`))
    img.src = imageUrl
  })

  if (!img.naturalWidth || !img.naturalHeight) {
    throw new Error(`Building image loaded with empty dimensions: ${imageUrl}`)
  }

  const data = {
    ...selectedImage,
    height: viewpointsImage?.height ?? selectedImage?.height,
    true_x: viewpointsImage?.x ?? selectedImage?.true_x,
    true_y: viewpointsImage?.y ?? selectedImage?.true_y,
  }

  return {
    image: imageUrl,
    processed_image: viewpointsImage?.processed_image_object,
    data,
    dimensions: {
      width: img.naturalWidth,
      height: img.naturalHeight,
    },
  }
}
